import { render, staticRenderFns } from "./CloudoffisLogo.vue?vue&type=template&id=15fa5154&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/packages/axiom-design-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15fa5154')) {
      api.createRecord('15fa5154', component.options)
    } else {
      api.reload('15fa5154', component.options)
    }
    module.hot.accept("./CloudoffisLogo.vue?vue&type=template&id=15fa5154&", function () {
      api.rerender('15fa5154', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/04-web-components/powerbar/assets/icons/CloudoffisLogo.vue"
export default component.exports